import styled from 'styled-components'

export const CardStyled = styled.div`
	padding: 1.5rem;
	border-radius: 1rem;
	box-shadow: 0px 2px 8px 0px rgba(9, 106, 99, 0.25);
`
